import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function UnderskinPage() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id: string) => {
    navigate('/', { state: { scrollTo: id } });
    setMobileMenuOpen(false);
  };

  const handleHomeClick = () => {
    navigate('/');
    setMobileMenuOpen(false);
  };

  const handleBackToHome = () => {
    navigate('/', { state: { scrollTo: 'underskin' } });
  };

  // Generate 24 images for the full gallery
  const images = Array.from({ length: 24 }, (_, i) => {
    const staticImages = [
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/f41c429a593e425ddebf0f0554c3322b.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/5318a36ed60c8426cf984cb73ee0dc73.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/f705ff6d80fdfe769ab50bbf93d197f7.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/361dd1928bfe0974df89a8dfe09ef4d2.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/b1869feefe72f800b805920f942f942c.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/f1a68ccbab3c0f0300456c0d2fe1fa33.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/f9b2238cc560be518543a56a8c5f7c8e.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/b8a96601e6bd12397296285b893b10ae.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/e8a0fd7c9a20a0c832c84a8243c16039.jpeg',
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/03630726116627bbb22ac771b63ce195.jpeg'
    ];
    
    return {
      id: i + 1,
      src: i < 10 
        ? staticImages[i]
        : `https://public.readdy.ai/ai/img_res/e5bc833a07eae985b8c9600c9f62c10c.jpg${i + 1}&orientation=squarish`
    };
  });

  return (
    <div className="bg-[#1a1a1a] text-white min-h-screen">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/85 backdrop-blur-sm' : 'bg-transparent'}`}>
        <div className="px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <button onClick={handleHomeClick} className="text-lg md:text-xl font-light tracking-wider cursor-pointer hover:text-[#e8dcc4] transition-colors">
            Dighsk
          </button>
          
          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              About
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('sculptures')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Sculptures
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('music')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Music
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('video')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Video Works
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('design')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Design
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <div className="flex items-center gap-4 ml-4 pl-4 border-l border-gray-600">
              <a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-music-2-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-sm border-t border-gray-800">
            <div className="px-4 py-6 space-y-4">
              <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                About
              </button>
              <button onClick={() => scrollToSection('sculptures')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Sculptures
              </button>
              <button onClick={() => scrollToSection('music')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Music
              </button>
              <button onClick={() => scrollToSection('video')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Video Works
              </button>
              <button onClick={() => scrollToSection('design')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Design
              </button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Contact
              </button>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-700">
                <a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                  <i className="ri-music-2-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Content */}
      <div className="pt-20 md:pt-24 pb-16 md:pb-24 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Back Button */}
          <button 
            onClick={handleBackToHome}
            className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors mb-8 md:mb-12 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span>Back to Home</span>
          </button>

          {/* Header */}
          <div className="mb-12 md:mb-16">
            <h1 className="text-4xl md:text-6xl font-light mb-6 text-[#e8dcc4]">Underskin</h1>
            <p className="text-sm md:text-base leading-relaxed text-gray-300 max-w-3xl">
              構造の露呈
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {images.map((image) => (
              <div 
                key={image.id}
                className="group cursor-pointer"
              >
                <div className="relative w-full aspect-square overflow-hidden transition-all duration-500 hover:-translate-y-2">
                  <img 
                    src={image.src}
                    alt={`Underskin ${image.id}`}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#0a0a0a] py-12 md:py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-3 mb-4 md:mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/0f42d2ce-e038-4c14-a91d-0b039870b3a6.png" 
                  alt="Dighsk Logo" 
                  className="h-6 md:h-8 w-6 md:w-8 object-contain"
                />
                <span className="text-lg md:text-xl font-light tracking-wider">Dighsk</span>
              </div>
              <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
                Structural Artist crossing boundaries through structure.
              </p>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-light mb-3 md:mb-4 text-[#e8dcc4]">Works</h4>
              <ul className="space-y-2">
                <li><button onClick={() => scrollToSection('sculptures')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Sculptures</button></li>
                <li><button onClick={() => scrollToSection('music')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Music</button></li>
                <li><button onClick={() => scrollToSection('video')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Videos</button></li>
                <li><button onClick={() => scrollToSection('design')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Design</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-light mb-3 md:mb-4 text-[#e8dcc4]">About</h4>
              <ul className="space-y-2">
                <li><button onClick={() => scrollToSection('about')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Biography</button></li>
                <li><a href="#" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Exhibitions</a></li>
                <li><a href="#" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Press</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-light mb-3 md:mb-4 text-[#e8dcc4]">Connect</h4>
              <ul className="space-y-2">
                <li><a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Instagram</a></li>
                <li><a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">SoundCloud</a></li>
                <li><a href="https://vimeo.com/dighsk" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Vimeo</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-xs md:text-sm text-gray-500 order-2 md:order-1">© 2025 Dighsk. All rights reserved.</p>
            <div className="flex items-center gap-4 md:gap-6 order-1 md:order-2">
              <a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base md:text-lg"></i>
              </a>
              <a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-music-2-line text-base md:text-lg"></i>
              </a>
              <a href="https://vimeo.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-video-line text-base md:text-lg"></i>
              </a>
              <a href="mailto:contact@dighsk.art" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-mail-line text-base md:text-lg"></i>
              </a>
            </div>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-500 hover:text-[#e8dcc4] transition-colors cursor-pointer order-3">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
